import { render, staticRenderFns } from "./InterimRequestNew.vue?vue&type=template&id=0ad38d1c&scoped=true&"
import script from "./InterimRequestNew.vue?vue&type=script&lang=js&"
export * from "./InterimRequestNew.vue?vue&type=script&lang=js&"
import style0 from "./InterimRequestNew.vue?vue&type=style&index=0&id=0ad38d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad38d1c",
  null
  
)

export default component.exports